class Logger {
   constructor() {
      this.DEBUG = process.env.VUE_APP_DEBUG === 'true';
      this.WARNING = true;
      this.ERROR =  true
   }

   debug(msg, label) {
      if (!this.DEBUG) return;
      try {
         console.log((label || "DEBUG") + ": " + JSON.stringify(msg));
      } catch (e) {
         console.log((label || "DEBUG"));
         console.log(msg);
      }
   }

   warn(msg) {
      if (this.WARNING) console.warn(msg);
   }

   error(msg) {
      if (this.ERROR) console.error(msg);
   }
}

export default new Logger()